define('GameDayCore/GDModel/ValueObjects/HotColdZone/HotColdSitFile',['require','exports','module','../ValueObjectFactory','./HotColdZone'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		HotColdZone = require('./HotColdZone')

	VO.create(HotColdSitFile);

	function HotColdSitFile($data, $isPitcher) {
		var vo = VO.ensureVO(this, HotColdSitFile),
			data = $data,
			zones = parseZones(data,$isPitcher);

		vo.num = data.num || "";
		vo.ab = data.ab || "";
		vo.avg = data.avg || "";
		vo.hr = data.hr || "";
		vo.rbi = data.rbi || "";
		vo.bb = data.bb || "";
		vo.so = data.so || "";
		vo.ops = data.ops || "";
		vo.rating = data.rating || "";
		vo.sweetness = data.sweetness || "";
		vo.zones = zones;
	}

	function parseZones(data,$isPitcher) {
		var zns = [],
			temp;

		for (var i = 0, len = data.zone.length; i < len; i++) {
			zns.push(new HotColdZone(data.zone[i]), $isPitcher);
		}

		return zns;
	}
	return HotColdSitFile;
});
